package com.essntl.core.unsplash.data

import com.essntl.config.EssntlConfig
import com.essntl.core.network.IO
import com.essntl.core.unsplash.data.response.UnsplashResponse
import com.essntl.core.unsplash.domain.UnsplashClient
import com.essntl.core.unsplash.domain.models.Picture
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext

internal class UnsplashClientImpl(
    private val httpClient: HttpClient,
): UnsplashClient {
    override suspend fun searchPhotos(
        query: String,
        page: Long,
    ): Result<List<Picture>> =
        runCatching {
            withContext(Dispatchers.IO) {
                httpClient.get("${BASE_URL}search/photos?client_id=${EssntlConfig.unsplashAccessKey}&page=${page}&per_page=${10}") {
                    url {
                        parameters.append("query", query)
                    }
                }
            }
                .body<UnsplashResponse>().results.map { it.toModel() }
        }

    companion object {
        private const val BASE_URL = "https://api.unsplash.com/"
    }
}